// Copyright (c) 2026 Solartek LLC. All rights reserved.

import { Skeleton } from '@/components/ui';
import { lazyPage } from '@/lib/lazy-page';

export const MeetingsPage = lazyPage(() => import('./meetings-page'));
export const MeetingDetailPage = lazyPage(() => import('./meeting-detail-page'));
/** The portal's /my/meetings (registered by features/portal/routes.tsx). */
export const MyMeetingsPage = lazyPage(() => import('./my-meetings-page'));

export function PageFallback() { return <div className="page-container space-y-4"><Skeleton className="h-8 w-64" /><Skeleton className="h-64 w-full" /></div>; }
